export class GetAdminsRequest {
  KeywordSearches: string[];
  PageNumber: number;
  ItemsPerPage: number;
  StatusFilter: number;
  Sorting: number;
}
